import { InjectionToken } from '@angular/core';
import { PaymentFeatureFlagAdapter } from '../../infrastructure/adapters/payment-feature-flag.adapter';
import { PaymentFeatureFlagService } from '../ports/payment-feature-flags';

export const PAYMENT_FEATURE_FLAGS = new InjectionToken<PaymentFeatureFlagService>('FeatureFlagService', {
  providedIn: 'root',
  factory: (): PaymentFeatureFlagService => new PaymentFeatureFlagAdapter()
});
